import React from 'react';
import { NavLink } from 'react-router-dom';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';


const slides = [
    {
        image: require('./../../images/our-team4/image00014.jpeg'),
        membername: 'Przemek "Kępol" Kępiński',
        position: 'Założyciel i prezes firmy ',
        description: ' Założyciel i prezes firmy. Człowiek o niespożytej energii i niezwykłej wyobraźni. Choć jego styl pracy bywa chaotyczny, to właśnie z tej kreatywnej burzy wyłaniają się najbardziej innowacyjne projekty. Jest pasjonatem budowy skateparków, a każda nowa realizacja to dla niego wyzwanie, które podejmuje z pełnym zaangażowaniem. Pracowity i nieustannie poszukujący nowych rozwiązań, inspiruje cały zespół do działania na najwyższych obrotach.',
        
    },
    // {
    //     image: require('./../../images/our-team4/pic2.png'),
    //     membername: 'Paulina Cwynar',
    //     position: 'Założycielka/Partner'
    // },
    // {
    //     image: require('./../../images/our-team4/pic3.png'),
    //     membername: 'Filip Madaj',
    //     position: 'Architekt/Freelancer'
    // },
    {
        image: require('./../../images/our-team4/image00010.jpeg'),
        membername: 'Bartosz Zabiega',
        position: 'Architekt/Koordynacja ',
        description: 'Nasz główny projektant i wspólnik Przemka, to architekt z pasją, który zdobył wykształcenie w Szwecji. Specjalizuje się w projektowaniu skateparków i snowparków, łącząc swoje zamiłowanie do deskorolki i snowboardu z fachową wiedzą architektoniczną. Spokojny i opanowany, wnosi do zespołu równowagę i precyzję, tworząc przestrzenie, które zachwycają zarówno estetyką, jak i funkcjonalnością.',
    },
   
    {
        image: require('./../../images/our-team4/image00012.jpeg'),
        membername: 'Robert "Rychu" Szpuła ',
        position: 'Brygadzista i frezer',
        description: 'Robert "Rychu" Szpuła - nasz brygadzista i frezer. To człowiek o imponującej sile i precyzji, zarówno w pracy, jak i na siłowni, gdzie zdobył tytuł króla muscle upów. Z wykształcenia ratownik medyczny, opanowany i inteligentny, a od niedawna także świeżo upieczony tata. Jego wszechstronność i profesjonalizm sprawiają, że kierowanie zespołem przy budowie skateparków to dla niego codzienność.'

    },
    {
        image: require('./../../images/our-team4/image00009.jpeg'),
        membername: 'Kacper "Dymek" Dymiński ',
        position: 'Monter skateparków',
        description: 'To prawdziwy pasjonat rolek agresywnych, który po godzinach trenuje dzieciaki w sekcji aggressive w klubie sportowym. Jego pełne zaangażowanie widać na każdym kroku, zarówno w pracy, jak i po godzinach. Wyróżnia się najbardziej raperskim stylem z całej ekipy – zawsze autentyczny, uczynny i z sercem na dłoni, gotowy, by wspierać innych.'
    },
    // {
    //     image: require('./../../images/our-team4/image00018.jpeg'),
    //     membername: 'Michał "Bigi" Bigus',
    //     position: 'Frezer i mistrz CNC.',
    //     description: ' Zaczyna każdy dzień bardzo wcześnie, zawsze aktywny, wszędzie dojeżdża rowerem i często spędza poranki na siłowni. W pracy łączy szybkość z precyzją, będąc niezwykle dokładnym w każdym zadaniu. Jako złota rączka potrafi poradzić sobie z różnorodnymi wyzwaniami. Choć bywa wybuchowy i działa jak indywidualista, zawsze można na nim polegać. Pasjonat deskorolki for life!'
    // },
    {
        image: require('./../../images/our-team4/image00016.jpeg'),
        membername: 'Robert "Szajbek" Schreiber ',
        position: 'Logistyk i monter',
        description: 'Najnowszy w naszej ekipie. To osoba o niesamowitym poczuciu humoru, zawsze wnosi radość i pozytywną energię do zespołu. Jest przyjazny, sumienny i dokładny, a jednocześnie honorowy w podejściu do swojej pracy. Jako świetny kierowca, dba o każdy szczegół związany z transportem i logistyką, jednocześnie perfekcyjnie spełniając swoje obowiązki na stanowisku montera.'
    },
]



const Team3 = () => {
    
    return (
        <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
            <div className="container">
                {/* TITLE START */}
                <div className="section-head">
                    <div className="mt-separator-outer separator-left">
                        <div className="mt-separator">
                            <h2 className="text-uppercase sep-line-one ">
                                <span className="font-weight-300 text-primary">Nasza</span> Ekipa
                            </h2>
                        </div>
                    </div>
                </div>
                {/* TITLE END */}
                {/* IMAGE Team START */}
                <div className="section-content">
                    <div className="row">
                        
                    <Slider className="slider-wrapper" autoplay={2000}>
                    
                    {slides.map((slide, index) => (
                        
                        <div
                        key={index}
                        className="slider-content"
                        style={{ background: `url('${slide.image}') no-repeat center center` }}
                        >
                        <div className="inner">
                            <h1>{slide.membername}</h1>
                            <h2>{slide.position}</h2>
                                                        <p>{slide.description}</p>
                        </div>
                        </div>
                        
                    ))}
                    </Slider>
                 

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Team3;